import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=d66fff5a&scoped=true&"
import script from "./SelectArea.vue?vue&type=script&lang=js&"
export * from "./SelectArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66fff5a",
  null
  
)

/* custom blocks */
import block0 from "./SelectArea.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports